/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  WebsiteStatistic,
  WebsiteStatisticRequest,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    WebsiteStatisticFromJSON,
    WebsiteStatisticToJSON,
    WebsiteStatisticRequestFromJSON,
    WebsiteStatisticRequestToJSON,
} from '../models';

export interface LoadAndReturnStatisticsRequest {
    xApplicationScope: ApplicationScope;
    websiteStatisticRequest: WebsiteStatisticRequest;
}

/**
 * 
 */
export class StatisticsControllerApi extends runtime.BaseAPI {

    /**
     * loads statistics based on input
     * loads statistics based on input
     */
    async loadAndReturnStatisticsRaw(requestParameters: LoadAndReturnStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebsiteStatistic>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling loadAndReturnStatistics.');
        }

        if (requestParameters.websiteStatisticRequest === null || requestParameters.websiteStatisticRequest === undefined) {
            throw new runtime.RequiredError('websiteStatisticRequest','Required parameter requestParameters.websiteStatisticRequest was null or undefined when calling loadAndReturnStatistics.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/statistics`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebsiteStatisticRequestToJSON(requestParameters.websiteStatisticRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebsiteStatisticFromJSON(jsonValue));
    }

    /**
     * loads statistics based on input
     * loads statistics based on input
     */
    async loadAndReturnStatistics(requestParameters: LoadAndReturnStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebsiteStatistic> {
        const response = await this.loadAndReturnStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
